import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import DetailIcon from "../assets/images/detail.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Footer from "../Components/common/footer";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import PropertyDamageTab from "../Components/Property-Damage/tabs/property-damage-tab";
// import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import AddEditPropertyDamage from "../Components/Property-Damage/tabs/modals/add-edit-property-damage";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import addIconGold from "../assets/Add-icon-gold.svg";
import usePropertyDamage from "../Components/Property-Damage/hooks/useGetPropertyDamage";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";

const PageContent = ({ setShowPropertyDamageModal, currentPage, data, refetch, pageIcon }) => {
  switch (currentPage) {
    case "all":
      return (
        <>
          <PropertyDamageTab
            setAddPropertyDmgModal={setShowPropertyDamageModal}
            data={data}
            refetch={refetch}
            pageIcon={pageIcon}
          />
        </>
      );
    case "photo":
      return <PhotoTab pageId={73} pageName={""} />;
    default:
      return null;
  }
};

function PropertyDamagePage() {
  // State management
  const [currentPage, setCurrentPage] = useState("all");
  const [viewType, setViewType] = useState("detailed");
  const [showPropertyDamageModal, setShowPropertyDamageModal] = useState(false);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);
  const { propertyDamage, refetch } = usePropertyDamage();

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 73).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);
  // Handlers
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  // Generate main tabs - each client, defendant, and party gets their own tab
  const mainTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });

    return tabs;
  }, [handlePageChange]);

  const actionTabs = useMemo(
    () => [
      {
        id: "add-property-damage",
        label: "Property Damage",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => setShowPropertyDamageModal(true),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
      },
    ],
    []
  );

  // Generate view tabs
  const viewTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "detailed",
      label: "Detail",
      className:
        viewType === "detailed"
          ? "active tab-trapezium-cycles-corners"
          : "tab-trapezium-cycles-corners",
      background: viewType === "detailed" ? "var(--primary) !important" : "var(--primary-60)",
      activeColor: "white",
      onClick: () => {
        setViewType("detailed");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center text-gold"
        >
          <img
            src={DetailIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    });

    return tabs;
  }, []);

  // Generate photo tabs
  const photoTabs = useMemo(
    () => [
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    [handlePageChange]
  );

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    // sending page ids directly now.
    fetchShakespeareStatus(caseId, 73, dispatch);
  }, [caseId, dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName={"73"} />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container overflow-hidden position-relative">
            <SmartResponsiveTabsContainer
              isEmpty={propertyDamage?.length === 0}
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={viewTabs}
              addTab={actionTabs}
              photoTab={photoTabs}
              handlePageChange={handlePageChange}
              viewType={viewType}
            />
            <div
              className="invisible-scrollbar h-100"
              style={{ overflowX: "hidden", overflowY: "scroll" }}
            >
              <PageContent
                setShowPropertyDamageModal={setShowPropertyDamageModal}
                currentPage={currentPage}
                data={propertyDamage}
                refetch={refetch}
                pageIcon={pageObject?.page_icon}
              />
              <NotesSectionDashboard pageName={"Insurance"} />
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {showPropertyDamageModal && (
        <AddEditPropertyDamage
          show={showPropertyDamageModal}
          handleClose={() => setShowPropertyDamageModal(false)}
          isEdit={false}
          refetch={refetch}
        />
      )}
    </>
  );
}

export default PropertyDamagePage;
